import {Alert, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, Link, MenuItem, Select, Table, TableBody, TableCell, TableRow, TextField} from "@mui/material"
import React from "react"
import {download} from "../../services/FileService";
import {Add, Close, Delete, Edit} from "@mui/icons-material";
import VisuallyHiddenInput from "../common/VisuallyHiddenInput";
import TableHead from "@mui/material/TableHead";
import {ROLES} from "../../util/Const";

const columns = [
    {id: 'name', label: 'Fájl Neve'},
    {id: 'description', label: 'Leírás'},
    {id: 'createdAt', label: 'Feltöltve'},
    {id: 'uploadedBy', label: 'Feltöltő'},
];

export default function UserEditorTemplate(props) {

    const [open, setOpen] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState(undefined);

    const handleClickOpen = (item) => {
        setCurrentItem(item)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Container component="main">
                <div className="register-paper">
                    <form id="login" onSubmit={props.id ? props.update : props.register}>
                        <Grid container columns={4}>
                            <Grid item md={1} xs={4}>
                                <Grid container columns={1} padding="20px" spacing={2}>
                                    <Grid item md={5} xs={20}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            fullWidth
                                            id="name"
                                            label="Név"
                                            name="name"
                                            type="text"
                                            autoComplete="off"
                                            autoFocus
                                            onChange={props.onChange}
                                            value={props.user.name || ""}
                                        />
                                    </Grid>

                                    <Grid item md={5} xs={20}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            fullWidth
                                            id="email"
                                            label="E-mail"
                                            name="email"
                                            type="email"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.email}
                                        />
                                    </Grid>

                                    {props.id === undefined && <><Grid item md={5} xs={20}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            fullWidth
                                            name="password"
                                            label="Jelszó"
                                            type="password"
                                            id="password"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.password}
                                        />
                                    </Grid>

                                        <Grid item md={5} xs={20}>
                                            <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                name="passwordCheck"
                                                label="Jelszó megerősítés"
                                                type="password"
                                                id="passwordCheck"
                                                autoComplete="off"
                                                onChange={props.onChange}
                                                value={props.user.passwordCheck}
                                            />
                                        </Grid>
                                    </>}
                                </Grid>
                            </Grid>

                            <Grid item md={1} xs={4} style={{borderLeft: "2px solid darkgray"}}>
                                <Grid container columns={1} padding="20px" spacing={2}>

                                    <Grid item md={8} xs={20}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            fullWidth
                                            name="hourlyRate"
                                            label="Óradíj"
                                            type="text"
                                            id="hourlyRate"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.hourlyRate}
                                        />
                                    </Grid>


                                    <Grid item md={4} xs={20}>
                                        <FormControl sx={{m: 1, minWidth: 120, marginTop: "16px", marginLeft: "0px"}}
                                                     fullWidth>
                                            <InputLabel id="roleLabel">Szerepkör</InputLabel>
                                            <Select
                                                variant="outlined"
                                                required
                                                fullWidth
                                                id="role"
                                                name="role"
                                                label="Szerepkör"
                                                labelId="roleLabel"
                                                value={props.user.role}
                                                onChange={props.onChange}
                                                sx={{textAlign: "left"}}
                                                defaultValue={"ROLE_EMPLOYEE"}
                                            >
                                                {Object.entries(ROLES).map(([key, value]) => (
                                                    <MenuItem value={key}>{value}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item md={4} xs={20}>
                                        <FormControl sx={{m: 1, minWidth: 120, marginTop: "16px", marginLeft: "0px"}}
                                                     fullWidth>
                                            <InputLabel id="salaryTemplateLabel">Fizetési Kategória</InputLabel>
                                            <Select
                                                variant="outlined"
                                                required
                                                fullWidth
                                                id="salaryTemplate"
                                                name="salaryTemplate"
                                                label="Fizetési Kategória"
                                                labelId="salaryTemplateLabel"
                                                value={props.user.salaryTemplate}
                                                onChange={props.onChange}
                                                sx={{textAlign: "left"}}
                                                defaultValue={"NORMAL"}
                                            >
                                                <MenuItem value={"NORMAL"}>Normál</MenuItem>
                                                <MenuItem value={"ONLY_HOUR_BASED"}>Csak Óra Alapú</MenuItem>
                                                <MenuItem value={"EXTERNAL_SUBCONTRACTOR"}>Külsős
                                                    Alvállalkozó</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item md={4} xs={20}>
                                        <FormControl sx={{m: 1, minWidth: 120, marginTop: "16px", marginLeft: "0px"}}
                                                     fullWidth>
                                            <InputLabel id="activeTemplateLabel">Státusz</InputLabel>
                                            <Select
                                                variant="outlined"
                                                required
                                                fullWidth
                                                id="active"
                                                name="active"
                                                label="Státusz"
                                                labelId="activeTemplateLabel"
                                                value={props.user.active}
                                                onChange={props.onChange}
                                                sx={{textAlign: "left"}}
                                                defaultValue={true}
                                            >
                                                <MenuItem value={true}>Aktív</MenuItem>
                                                <MenuItem value={false}>Inaktív</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item md={2} xs={4} style={{borderLeft: "2px solid darkgray"}}>
                                <Grid container columns={2} padding="20px" spacing={2}>

                                    <Grid item md={1} xs={2}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="monthlySzja"
                                            label="SZJA Összege (havonta)"
                                            type="text"
                                            id="monthlySzja"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.monthlySzja}
                                        />
                                    </Grid>

                                    <Grid item md={1} xs={2}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="monthlyFuelCost"
                                            label="Benzinpénz (Ft/km)"
                                            type="text"
                                            id="monthlyFuelCost"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.monthlyFuelCost}
                                        />
                                    </Grid>

                                    <Grid item md={1} xs={2}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="dailySicknessBenefitAmount"
                                            label="Táppénz Összege (naponta)"
                                            type="text"
                                            id="dailySicknessBenefitAmount"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.dailySicknessBenefitAmount}
                                        />
                                    </Grid>

                                    <Grid item md={1} xs={2}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="transferredSalaryAmount"
                                            label="Átutalt Bér (havonta)"
                                            type="text"
                                            id="transferredSalaryAmount"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.transferredSalaryAmount}
                                        />
                                    </Grid>

                                    <Grid item md={1} xs={2}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="yearlyDayOffs"
                                            label="Szabadságok Száma (Évente)"
                                            type="text"
                                            id="yearlyDayOffs"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.yearlyDayOffs}
                                        />
                                    </Grid>

                                    <Grid item md={1} xs={2}>
                                        <TextField
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="availableDayOffs"
                                            label="Maradék Szabadság"
                                            type="text"
                                            id="availableDayOffs"
                                            autoComplete="off"
                                            onChange={props.onChange}
                                            value={props.user.availableDayOffs || ""}
                                        />
                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid item md={4} xs={4}>
                                <Grid container spacing={2} columns={5} sx={{marginTop: "4px"}}>
                                    {(props.user?.files?.length > 0 || props.files?.length > 0) &&
                                        <Grid item xs={5}>
                                            <Table sx={{marginTop: "16px"}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell key="actions"
                                                                   style={{fontWeight: 700, background: "lightgray", minWidth: "50px"}}
                                                                   align='left' padding='none' sx={{paddingLeft: "8px"}}>
                                                            <Button variant='contained' color='success' component={'label'}
                                                                    sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}>
                                                                <VisuallyHiddenInput type="file" multiple
                                                                                     onChange={props.handleFileChange}/>
                                                                <Add fontSize="large"/>
                                                            </Button>
                                                        </TableCell>
                                                        {columns.map((column) => (
                                                            <TableCell key={column.id} align={column.align}
                                                                       style={{fontWeight: 700, background: "lightgray"}}>
                                                                {column.label}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.user?.files?.map((file, index) => (
                                                        <TableRow>
                                                            <TableCell sx={{width: "50px", padding: "0px"}}>
                                                                <Button
                                                                    onClick={() => props.removeDocumentName(file.id)}
                                                                    variant="text" color='error' sx={{
                                                                    marginLeft: "10px",
                                                                    padding: "5px",
                                                                    minWidth: "0px"
                                                                }}>
                                                                    <Delete/>
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell key={index}
                                                                       sx={{textAlign: "left", padding: "5px"}}>
                                                                <Link
                                                                    onClick={() => download(file.name, `/cloud-storage-files/${file.id}`, props.sendAlertMessage)}
                                                                    sx={{
                                                                        textDecoration: "none",
                                                                        cursor: "pointer",
                                                                        fontWeight: "bold"
                                                                    }}>{file.name}</Link>
                                                            </TableCell>
                                                            <TableCell>
                                                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: "0px"}}>
                                                                    <span style={{flexGrow: 1, textAlign: 'left'}}>{file.description}</span>
                                                                    <Button onClick={() => handleClickOpen(file)} variant="text" sx={{minWidth: '0px', padding: '5px', marginLeft: 'auto'}}>
                                                                        <Edit/>
                                                                    </Button>
                                                                </span>
                                                            </TableCell>

                                                            <TableCell>{file.createdAt}</TableCell>
                                                            <TableCell>{file.uploadedBy?.name}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    {props.files.map((file, index) => (
                                                        <TableRow>
                                                            <TableCell sx={{width: "50px", padding: "0px"}}>
                                                                <Button
                                                                    onClick={() => props.handleRemoveFile(index)}
                                                                    variant="text" color='error' sx={{
                                                                    marginLeft: "10px",
                                                                    padding: "5px",
                                                                    minWidth: "0px"
                                                                }}>
                                                                    <Close/>
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell key={index} sx={{
                                                                textAlign: "left",
                                                                padding: "0px 0px 0px 5px"
                                                            }}>
                                                                {file.name} {' ('}{(new Intl.NumberFormat().format((file.size / 1024).toFixed(2))).replace(',', '.')} KB{')'}
                                                            </TableCell>
                                                            <TableCell></TableCell>
                                                            <TableCell></TableCell>
                                                            <TableCell></TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </Grid>}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container columns={20} sx={{marginTop: "16px"}}>
                            {props.message &&
                                <Grid item md={20} xs={20}>
                                    <Alert severity="error" variant="standard"
                                           style={{color: "red"}}>{props.message}</Alert>
                                </Grid>
                            }

                            <Grid item lg={2} md={5} xs={9}>
                                <Button type="button" fullWidth variant="contained" color="error"
                                        onClick={() => props.navigate("/dashboard/users")}>
                                    Vissza
                                </Button>
                            </Grid>

                            <Grid item lg={16} md={10} xs={2}></Grid>

                            <Grid item lg={2} md={5} xs={9}>
                                {props.waitingForServer ? <CircularProgress sx={{margin: "-5px"}}/> :
                                    <Button type="submit" fullWidth variant="contained" color="success">
                                        Mentés
                                    </Button>}
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Container>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        props.updateFileDescription(currentItem.id, formJson)
                        handleClose();
                    },
                }}
            >
                <DialogTitle sx={{background: "#1976d2", color: "white"}}>
                    Fájl Leírás Módosítása
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="description"
                        label="Leírás"
                        fullWidth
                        autoComplete="off"
                        defaultValue={currentItem?.description}
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained"
                            sx={{marginRight: "auto"}}>Mentés</Button>
                    <Button onClick={handleClose} color="error"
                            variant="outlined">Mégse</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}